import React, { Component } from "react";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import * as profileActions from "../../../../_actions/profileActions";
import getMemberPartnerPreference from "../../../../_selectors/profileSelectors/getMemberPartnerPreference";
import PreferenceStat from "./PreferenceStat";
import getMyUserProfileRaw from "../../../../_selectors/userSelectors/getMyUserProfileRaw";
import getMemberName from "../../../../_selectors/profileSelectors/getMemberName";
import getMemberLocationForProfile from "../../../../_selectors/profileSelectors/getMemberLocationForProfile";
import getDisplayName from "../../../../_selectors/userSelectors/getDisplayName";
import getMyLocationForProfile from "../../../../_selectors/userSelectors/getMyLocationForProfile";
class PreferenceMatch extends Component {
  componentDidMount() {
    const { memberPreference, getMemberPreferenceData, profileId } = this.props;
    if (memberPreference.cache) {
      getMemberPreferenceData({ profileId });
    }
  }
  render() {
    const {
      memberPreference,
      userProfile,
      memberName,
      memberLocation,
      name,
      location
    } = this.props;
    return (
      <div class="dev-invoice">
        <div class="dev-invoice-sides">
          <div class="dev-invoice-sides-left">
            {memberName}
            <br />
            <span>{memberLocation}</span>
          </div>
          <div class="dev-invoice-sides-separator">
            <i class="fa fa-angle-right" />
          </div>
          <div class="dev-invoice-sides-right">
            {name}
            <br />
            <span>{location}</span>
          </div>
        </div>

        <table class="dev-invoice-table">
          <tbody>
            <tr>
              <th width="20%" />
              <th width="60%" />
              <th width="20%" />
            </tr>
            <tr>
              <td>Age</td>
              <td>
                <strong>
                  {memberPreference.ageStart} to {memberPreference.ageEnd}
                </strong>
              </td>
              <td>
                {userProfile.age ? (
                  userProfile.age > memberPreference.ageStart &&
                  userProfile.age < memberPreference.ageEnd ? (
                    <strong className="label label-success">Match</strong>
                  ) : (
                    <strong className="label label-danger">No Match</strong>
                  )
                ) : (
                  <strong className="label label-danger">No Match</strong>
                )}
              </td>
            </tr>

            <PreferenceStat
              label="Marital Status"
              memberPreference={memberPreference.maritalStatus}
              userProfile={userProfile.maritalStatus}
            />
            <PreferenceStat
              label="Religion"
              memberPreference={memberPreference.religion}
              userProfile={userProfile.religion}
            />
            <PreferenceStat
              label="Mother Tongue"
              memberPreference={memberPreference.motherTongue}
              userProfile={userProfile.motherTongue}
            />
            <PreferenceStat
              label="Complexion"
              memberPreference={memberPreference.complexion}
              userProfile={userProfile.complexion}
            />
            <PreferenceStat
              label="Body Type"
              memberPreference={memberPreference.bodyType}
              userProfile={userProfile.bodyType}
            />
            <PreferenceStat
              label="Diet"
              memberPreference={memberPreference.diet}
              userProfile={userProfile.diet}
            />
            <PreferenceStat
              label="Smoking"
              memberPreference={memberPreference.smoking}
              userProfile={userProfile.smoking}
            />
            <PreferenceStat
              label="Drinking"
              memberPreference={memberPreference.drinking}
              userProfile={userProfile.drinking}
            />
            <PreferenceStat
              label="Education"
              memberPreference={memberPreference.education}
              userProfile={userProfile.education}
            />
            <PreferenceStat
              label="Employed In"
              memberPreference={memberPreference.employedIn}
              userProfile={userProfile.employedIn}
            />
            <PreferenceStat
              label="Job Type"
              memberPreference={memberPreference.jobType}
              userProfile={userProfile.jobType}
            />
            <PreferenceStat
              label="Income"
              memberPreference={memberPreference.income}
              userProfile={userProfile.income}
            />
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  memberPreference: getMemberPartnerPreference(state),
  userProfile: getMyUserProfileRaw(state),
  memberName: getMemberName(state),
  memberLocation: getMemberLocationForProfile(state),
  name: getDisplayName(state),
  location: getMyLocationForProfile(state)
});
const mapDispatchToProps = dispatch => ({
  getMemberPreferenceData: payload =>
    dispatch(profileActions.getMembersPartnerPreference(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreferenceMatch);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/PreferenceMatch/index.js